<template>
  <div class="fractional-numeric-entry-component-container">
    <div
      v-if="answered"
      class="answered"
    >
      <label>Answer:</label>
      <div class="answer selected">
        <div
          :class="{correct: correct}"
          class="icon"
        />
        {{ correct ? correctNumerator : numerator }} / {{ correct ? correctDenominator : denominator }}
      </div>
      <div
        v-if="!correct"
        class="answer"
      >
        <div class="correct icon" />
        {{ correctNumerator }} / {{ correctDenominator }}
      </div>
    </div>
    <div
      v-else
      class="unanswered"
    >
      <input
        v-model="numerator"
        placeholder="Numerator"
        type="number"
        @blur="blur"
        @focus="focus"
      >
      <span>/</span>
      <input
        v-model="denominator"
        placeholder="Denominator"
        type="number"
        @blur="blur"
        @focus="focus"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    answered: {
      type: Boolean,
      default: false,
    },
    correct: {
      type: Boolean,
      default: false,
    },
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    flashcardState: {
      type: Object,
      default: () => ({}),
    },
    rawAnswerData: {
      type: Object,
    },
  },
  emits: ['set-raw-answer-data'],
  computed: {
    correctDenominator() {
      return JSON.parse(this.flashcard.answers[0].text).denominator;
    },
    correctNumerator() {
      return JSON.parse(this.flashcard.answers[0].text).numerator;
    },
    denominator: {
      get() {
        if (this.flashcardState.rawAnswerData) {
          return this.flashcardState.rawAnswerData.denominator;
        }
        return (this.rawAnswerData || {}).denominator;
      },
      set(value) {
        let existing = this.rawAnswerData || {};
        this.$emit('set-raw-answer-data', {...existing, ...{denominator: value}});
      },
    },
    numerator: {
      get() {
        if (this.flashcardState.rawAnswerData) {
          return this.flashcardState.rawAnswerData.numerator;
        }
        return (this.rawAnswerData || {}).numerator;
      },
      set(value) {
        let existing = this.rawAnswerData || {};
        this.$emit('set-raw-answer-data', {...existing, ...{numerator: value}});
      },
    },
  },
  created() {
    this.$emit('set-raw-answer-data', {numerator: null, denominator: null});
  },
  methods: {
    blur() {
      this.$store.commit('appState/setInputtingText', false);
    },
    focus() {
      this.$store.commit('appState/setInputtingText', true);
    },
  },
};
</script>

<style lang='scss' scoped>
  .fractional-numeric-entry-component-container {
    margin: rem-calc(32) 0;

    .unanswered {
      input {
        background: #dfe3e9;
        border: solid 1px rgba(0,0,0,0.1);
        border-radius: 4px;
        margin-right: rem-calc(4);
        padding: rem-calc(6);
        text-align: center;
        width: rem-calc(120);

        &::-webkit-inner-spin-button, &::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }

      span {
        color: #666666;
        font-size: rem-calc(22);
        font-weight: $semi-bold;
        margin: 0 rem-calc(16);
      }
    }

    .answered {
      label {
        font-size: rem-calc(18);
      }

      .icon {
        @include incorrect-svg(#FA726F);
        background-size: contain;
        height: rem-calc(16);
        margin-right: rem-calc(12);
        width: rem-calc(16);

        &.correct {
          @include correct-svg(#70CF63);
        }
      }

      .answer {
        align-items: center;
        display: flex;
        margin-top: rem-calc(16);
      }

      .selected {
        font-weight: $semi-bold;
      }
    }
  }
</style>
